import styled from 'styled-components';
import { spacing, screen, container } from 'theme';
import { getPostThumb } from '../utils/blogUtils';
import {
  WP_REST_API_Categories,
  WP_REST_API_Post,
  WP_REST_API_Tags
} from 'wp-types';
import { useI18n } from 'hooks/useI18n';
import BlogCard from 'components/marketingSite/blog/cards/BlogCard';

const Container = styled.div`
  margin: ${spacing('xl3')} auto;
  max-width: ${container('xl')};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledBlogCards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing('lg')};
  width: 100%;

  @media (min-width: ${screen('md')}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: ${screen('lg')}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

interface Props {
  relatedPosts: WP_REST_API_Post[];
  currentPost?: WP_REST_API_Post;
  categories: WP_REST_API_Categories;
  locale?: string;
  tags?: WP_REST_API_Tags;
}

export const RecommendedPosts: React.FC<Props> = ({
  relatedPosts,
  currentPost,
  categories,
  locale,
  tags
}) => {
  const { t } = useI18n('success-stories');

  if (!relatedPosts.length) return null;

  return (
    <Container>
      <h2>{t('post.related')}</h2>
      <StyledBlogCards>
        {relatedPosts.map((item) => (
          <BlogCard
            post={item}
            key={item.slug}
            title={item.title.rendered}
            url={item.slug}
            thumb={getPostThumb(item)}
            date={item.date}
            allTags={tags}
          />
        ))}
      </StyledBlogCards>
    </Container>
  );
};
